import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { cn } from 'Utils/cn';
import IconIvoiceFile from 'assets/icon-invoice-file.svg';
import useLocale from 'Hooks/useLocale';
import { formatCurrency } from 'Utils/formatters';
import OutlineArrowRight from 'Components/Atoms/OutlineIcons/OutlineArrowRight';

function formatDate(date, locale) {
    if (!date) return '-';

    return date.toLocaleDateString(locale, { month: '2-digit', day: '2-digit', year: 'numeric' });
}

export default function InvoiceQuickEditorDrawerRelatedItem({ invoice, onClick, className }) {
    const { t } = useTranslation('invoices');
    const locale = useLocale();

    return (
        <button
            type="button"
            onClick={onClick}
            className={cn(
                'group grid grid-cols-[64px_1fr_auto] text-left gap-3 items-center md:grid-cols-[84px_1fr_auto]',
                className,
            )}
        >
            <div className="rounded-sm bg-gray-100 flex items-center justify-center min-h-16">
                <img src={IconIvoiceFile} alt="" />
            </div>

            <div className="min-w-0 grow">
                <div className="truncate font-semibold mb-0.5 text-dark-blue">
                    {invoice.identifier || t('no-identifier')}
                </div>
                <div className="flex gap-x-4 flex-wrap text-xs text-gray-500">
                    {invoice.invoice_party_display_name && <span>{invoice.invoice_party_display_name}</span>}
                    {invoice.date_emission && <span>{formatDate(invoice.date_emission, locale)}</span>}
                    {invoice.amount != null && (
                        <span>{formatCurrency(invoice.amount, { currency: invoice.currency, locale })}</span>
                    )}
                </div>
            </div>
            <div className="flex items-center text-gray-500">
                <OutlineArrowRight color="currentColor" className="group-hover:translate-x-1 transition-transform" />
            </div>
        </button>
    );
}

InvoiceQuickEditorDrawerRelatedItem.propTypes = {
    invoice: PropTypes.shape({
        id: PropTypes.string.isRequired,
        identifier: PropTypes.string,
        date_emission: PropTypes.instanceOf(Date),
        amount: PropTypes.number,
        currency: PropTypes.string,
        invoice_party_display_name: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
};
